import { withStyles, withWidth, makeStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import classNames from "classnames";
import numeral from 'numeral';
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import api, { baseURL } from 'shared/functions/api/';
import styled from 'styled-components';
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import BackButton from './../../../../shared/components/BackButton';
import SecondaryNav from './../components/SecondaryNav';
import style from './styles.module.scss';
import stylesMobile from './styles-mobile.module.scss';
import MessageDialog from "./../../dialog/MessageDialog";
import Tooltip from '@material-ui/core/Tooltip';
import Carousel from 'react-material-ui-carousel';
import Paper from '@material-ui/core/Paper';
import { isOtherShape } from 'logged_out/components/diamonds/All';
import getSymbolFromCurrency from 'currency-symbol-map';
import DiamondSideDrawer from './../components/DiamondSideDrawer';
import { DiamondDetailsList } from './../components/DiamondRowDetails';
import RelatedOffers from './RelatedOffers';
import smoothScrollTop from "shared/functions/smoothScrollTop";
import { convertToCurrency } from "shared/functions/priceCalc";

import Images360Player from './../components/Images360Player';

function joinHenigArray(d, field) {
    return [d[field][0].From, d[field][1].To].filter(s => s).join(' to ')
}

const useStyles = makeStyles((theme) => ({
    carousel: {
        textAlign: 'center',
        width: '100%',
    }
}));

function CarouselView({ items = [] }) {

    const classes = useStyles();

    return (
        <Carousel
            autoPlay={false}
            classes={{ root: classes.carousel }}
            navButtonsProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                style: {
                    minWidth: 'auto',
                    height: 'auto',
                    display: 'none',
                }
            }}
            indicatorIconButtonProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                style: {
                    minWidth: 'auto',
                    height: 'auto',
                    color: '#afafaf',
                    marginTop: 10,
                }
            }}
            activeIndicatorIconButtonProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                style: {
                    color: '#494949',
                }
            }}
            navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
                style: {
                    bottom: '0',
                    top: 'unset'
                }
            }}
        >
            {items.map((item, i) => <Item key={i} item={item} />)}
        </Carousel>
    )
}

function Item(props) {
    const { item } = props;
    return (
        <Paper>
            {item.type === 'image' && <img style={{ width: '100%', height: 'auto' }} src={baseURL + item.src} />}
            {item.type === 'video' && <video style={{ width: '100%', height: '100%' }} controls autoPlay>
                <source src={`${baseURL}${item.src}`} type="video/mp4" />
                {/* <source src="movie.ogg" type="video/ogg" /> */}
                Your browser does not support the video tag.
            </video>}
        </Paper>
    )
}

const styles = theme => ({

});


const PriceTag = styled(props => <div {...props}>
    <div>
        {!props.specialOffer && <React.Fragment><span><small>{props.isParcel ? 'Price per carat' : 'Price'}: </small>{props.price.split('.')[0]}</span><span className="text-style-2">.{props.price.split('.')[1]}</span></React.Fragment>}
        {props.specialOffer && <React.Fragment>
            <span>
                {props.priceOrig && <small className={'orig-price-line-through'}>{props.isParcel ? 'Price per carat: ' : props.priceOrig}</small>} 
                <span className="special-price-price">{props.price.split('.')[0]}</span>
            </span>
            <span className="text-style-2 special-price-price">.{props.price.split('.')[1]}</span>
        </React.Fragment>}
        {props.isAuthorised && <img alt="" src="/images/info.svg" />}
    </div>
</div>)`
height: 35px;
font-family: Lato;
font-size: 23px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: 1;
letter-spacing: normal;
text-align: left;
color: #24272b;

small{
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #6d7279;
}

.orig-price-line-through{
    font-size: inherit;
    text-decoration: line-through;
    margin-right: 10px;
    color: #b3b3b3;
}
.special-price-price{
    color: #b08f6e;
}

.text-style-2 {
    font-size: 19px;
}

img{
    vertical-align: middle;
    margin-left: 5px;
    cursor: pointer;
}
`;

export const RegisterOrLoginToSeePriceNotice = styled(props => {
const { description='to view prices' } = props;
return <div {...props}>
        <span className="text-style-1" onClick={() => props.openEmailDialog({ after: window.location.pathname })}>Sign In/Register</span> {description}
    </div>;
})`
padding-left: 0 !important;
margin: 0;
font-family: Lato;
font-size: 15px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 1.2;
letter-spacing: normal;
text-align: left;
color: #b6b8bc;

.text-style-1{
    font-weight: 500;
    color: #484f57;
    text-decoration: underline;
    cursor: pointer;
}
`;

const Report = ({row, openReportPDF, certificates=[]}) => {

    return (<div className={style.contentWrapRightInnerTableDiamondReportWrapper}>
        <div className={style.reportHeading}>
            {row.StkCertSup && row.StkCertSup.toLowerCase() === 'gia' && <img alt="" className={style.logoImg} src="/images/GIA@2x.jpg" />}
        </div>
        <div className={style.smallerHeading}>
            {row.StkCertSup} Natural Diamond Dossier
        </div>
        <div className={style.infoWrap}>
            <div className={style.infoRow}>
                <div className={style.infoCol}>{/* June 18, 2020 */}</div>
                <div className={style.infoCol}></div>
            </div>
            <div className={style.infoRow}>
                <div className={style.infoCol}>{row.StkCertSup} Report Number:</div>
                <div className={style.infoCol}>{row.StkCertNo}</div>
            </div>
            <div className={style.infoRow}>
                <div className={style.infoCol}>Shape and Cutting Style:</div>
                <div className={style.infoCol}>{row.StkDesc}</div>
            </div>
            <div className={style.infoRow}>
                <div className={style.infoCol}>Measurements:</div>
                <div className={style.infoCol}>{[row.StkMes1, row.StkMes2, row.StkMes3].map(s => s && `${s}mm` || '-').join(' x ')}</div>
            </div>
        </div>
        <div className={style.smallerHeading}>
            Proportions
        </div>

        <img alt="" src="/images/Screenshot 2020-11-14 at 21.58.38.jpg" />

        <div className={style.viewFullReport}>
            {(row.StkCertSup && row.StkCertSup.toLowerCase() === 'gia' || certificates.length > 0) && <Button onClick={() => openReportPDF()}>View or Download Full Report</Button>}
        </div>

        <img alt="" src="/images/badge.png" className={style.badge} />
    </div>);
}

const Diagram = ({ row, isMobile }) => {

    return (<div className={style.contentWrapRightInnerTableDiamondDiagramWrapper}>

        <div className={style.measurementsView}>
            <div className={style.innerWrap}>
                <img alt="" src="/images/diamond outline - up view.svg" />
                <div className={style.widthDivider}></div>
                <div className={style.widthMeasure}>
                    <label>Width:</label>
                    <b>{row.StkMes2 ? row.StkMes2 + ' mm' : '-'}</b>
                </div>
            </div>
            <div className={style.rightWrap}>
                <div className={style.heightDivider}></div>
                <div className={style.heightMeasure}>
                    <label>Length:</label>
                    <b>{row.StkMes1 ? row.StkMes1 + ' mm' : '-'}</b>
                </div>
            </div>
        </div>

        <div className={style.measurementsView}>

            <div className={classNames(style.rightWrap, style.depthMeasure)}>

                <div className={style.innerRowMeasureCol}>
                    <div className={style.innerRowMeasure} style={{ height: '30%' }}>
                        <div className={style.heightMeasure} style={{ textAlign: 'right' }}>
                            {!isMobile && <>
                                <label>Crown Height:</label>
                                <b>{row.StkDepth_Crown ? row.StkDepth_Crown + '%' : '-'}</b>
                            </>}
                            <label style={{ marginTop: !isMobile ? 7 : 38 }}>Girdle:</label>
                            <b>{row.StkDepth_Girdle ? row.StkDepth_Girdle + '%' : '-'}</b>
                        </div>
                        <div className={style.heightDivider}></div>
                    </div>

                    <div className={style.innerRowMeasure} style={{ marginTop: 2, height: '58%', marginBottom: 2 }}>
                        {!isMobile && <div className={style.heightMeasure} style={{ textAlign: 'right' }}>
                            <label>Pavillion Depth:</label>
                            <b>{row.StkDepth_Pavilion ? row.StkDepth_Pavilion + '%' : '-'}</b>
                        </div>}
                        <div className={style.heightDivider}></div>
                    </div>
                </div>
            </div>

            <div className={style.innerWrap}>
                <div className={style.widthMeasure} style={{ marginTop: -24 }}>
                    <label>Table:</label>
                    <b>{row.StkTable}%</b>
                </div>
                <div className={style.widthDivider} style={{ margin: '0 auto', width: '53%', marginBottom: 14 }}></div>
                <img alt="" src="/images/diamond outline - front view.svg" />
                <div className={style.culetDivider}></div>
                <div className={style.widthMeasure}>
                    <label>Culet:</label>
                    <b>{row.StkCulet ? row.StkCulet + '°' : '-'}</b>
                </div>
            </div>

            <div className={classNames(style.rightWrap, style.depthMeasure)} style={{height: '82%'}}>
                <div className={style.heightDivider}></div>
                <div className={style.heightMeasure}>
                    <label>Depth:</label>
                    <b>{row.StkDepth_Total ? row.StkDepth_Total + '%' : '-'}</b>
                </div>
            </div>
        </div>

    </div>);
}

const innerTabsValues = ['details', 'report', 'diagram'];

class DiamondDetails extends PureComponent {
    state = {
        innerTab: 0,
        selectedDiamondImage: 0,
        sideDrawerOpen: false,
        row: {},
        isParcel: false,
        loading: true,

        dialogOpen: false,
        dialogOpenProps: {},
        images: [],
        certificates: [],

        otherView: false,
        show360View: false,
        carouselView: false,
    }

    componentDidMount() {
        const { selectDiamondDetails = () => { } } = this.props;
        const { diamondId } = this.props.match.params;

        selectDiamondDetails();

        this.fetchDiamond(diamondId)

        // open 360 automatically for development
        // setTimeout(() => {
        //     this.on360Click()
        // }, 1000)
    }

    componentDidUpdate(prevProps) {
        const { diamondId } = this.props.match.params;
        if (!prevProps.diamondsData && this.props.diamondsData || diamondId !== this.state.row._id) {
            this.fetchDiamond(diamondId)
        }
    }

    fetchDiamondImages = async (diamondId) => {
        const res = await api.get(`/diamonds/${diamondId}/images`);
        this.setState({ images: res.data.filter(i => i.type !== '360'), video360: res.data.find(i => i.type == '360')  })
    }

    fetchDiamondCertificates = async (diamondId) => {
        const res = await api.get(`/diamonds/${diamondId}/certificates`);
        this.setState({ certificates: res.data })
    }

    fetchDiamond = async (id) => {
        const { page } = this.props.match.params;

        this.setState({
            loading: true,
            innerTab: page ? innerTabsValues.indexOf(page) : 0,
            selectedDiamondImage: 0,
        })

        if (!this.props.diamondsData) return;

        const d = this.props.diamondsData.docs.find(d => d._id === id);
        const isParcel = d.StkCatType === 'Multiple Items' ? true : false;

        function mapDiamond(d) {
            d.WebSpecial = parseFloat(d.WebSpecial)
            return {
                ...d,
                img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
                imgSide: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : ' side.png'}`,
                colour: joinHenigArray(d, 'Colour'),
                clarity: joinHenigArray(d, 'Clarity'),
                cut: joinHenigArray(d, 'Cut'),
                flourecence: joinHenigArray(d, 'flourecence'),
                symmetry: joinHenigArray(d, 'Symmetry'),
                polish: joinHenigArray(d, 'Polish'),
                size: joinHenigArray(d, 'Size'),
                availability: d.Availability || d.StkWebAvailable,
                price: !isParcel ? (d.WebSpecial || d.price || d.ExWebTotal) : (d.WebSpecial || d.ppc),
                priceOrig: d.ppc,
                specialOffer: d.WebSpecial ? true : false,
            };
        }


        this.setState({
            loading: false,
            row: mapDiamond(d),
            isParcel,
        })

        this.fetchDiamondImages(id)
        this.fetchDiamondCertificates(id)
    }

    handleChangeInnerTab(innerTab) {
        this.setState({ innerTab, otherView: false })
        this.props.history.push(innerTabsValues[innerTab])
    }

    on360Click() {
        const { video360 } = this.state;
        if(!video360){
            this.openComingSoonMessageDialog();
        }else{
            this.handleChangeInnerTab(0);
            this.setState({otherView: true, show360View: true })
        }
    }

    showCarousel() {
        const { images = [] } = this.state;
        if (images.length === 0) return;
        this.setState({
            otherView: true,
            carouselView: true,
            selectedDiamondImage: 2,
        })
    }

    showFrontImage() {
        this.setState({
            selectedDiamondImage: 0,
            otherView: false,
        })
    }

    showSideImage() {
        const { isParcel } = this.state;
        if (isParcel) return;
        this.setState({
            selectedDiamondImage: 1,
            otherView: false,
        })
    }

    closeOtherView() {
        this.setState({ otherView: false, selectedDiamondImage: 0 })
    }

    openComingSoonMessageDialog() {
        this.setState({
            dialogOpen: "message",
            dialogOpenProps: {
                headline: ('Coming Soon'),
                description: '',
                onComplete: () => {
                    this.closeDialog();
                },
                hideBackButton: true,
            },
        });
    }

    closeDialog = () => {
        this.setState({ dialogOpen: null });
    };

    openBag = () => {
        this.props.AuthActions.addToBag(this.state.row, () => {
            this.setState({ sideDrawerOpen: 'bag' });
        });
    };
    openBagShare = () => {
        this.setState({ sideDrawerOpen: 'share' });
    };
    openPrice = () => {
        this.setState({ sideDrawerOpen: 'price' });
    };
    closeBag = () => {
        this.setState({ sideDrawerOpen: false });
    };

    toggleFav(row, value) {
        const { favouriteItemsList } = this.props;
        this.props.DiamondsActions.setFavourite(value ? [...favouriteItemsList, row] : favouriteItemsList.filter(c => c._id !== row._id))
    }

    toggleCompare(_id, value) {
        const { compareItemsList } = this.props;
        this.props.DiamondsActions.setCompare(value ? [...compareItemsList, _id] : compareItemsList.filter(c => c !== _id))
    }

    convertToCurrency(amount, isParcel) {
        const { fxrates = [], ccy } = this.props;
        return convertToCurrency(amount, isParcel, fxrates, ccy);
    }

    loadRelatedItem(row) {
        smoothScrollTop();
        this.closeOtherView();
        this.props.history.push(`/diamonds/${row._id}/details`);
    }

    async openReportPDF(row) {
        const { diamondId } = this.props.match.params;
        const { isAuthorised, openEmailDialog, pushMessageToSnackbar } = this.props;
        const { certificates=[] } = this.state;

        if (!isAuthorised) {
            return openEmailDialog({ after: window.location.pathname });
        }

        var windowReference = window.open();

        try {
            if(certificates.length > 0){
                windowReference.location = baseURL + certificates[0].src;
                return;
            }

            const res = await api.get(`/diamonds/${diamondId}/certificate`);
            windowReference.location = res.data.report1.links.pdf;
        } catch (err) {
            pushMessageToSnackbar({
                isErrorMessage: true,
                text: err.response.data.map(d => `${d.errorType}: ${d.message}`).join(<br />)
            });
        }
    }

    render() {
        const { innerTab, selectedDiamondImage, otherView, sideDrawerOpen, row, isParcel, loading, dialogOpen, dialogOpenProps, show360View, carouselView, images = [], certificates = [], video360 } = this.state;
        const { /* classes, authUser, */ isAuthorised, openEmailDialog, compareItemsList, favouriteItemsList, ccy, fxrates = [], width } = this.props;
        const { diamondId, page } = this.props.match.params;
        const isFav = favouriteItemsList.find(f => f._id === diamondId);
        const isCompare = compareItemsList.includes(diamondId);
        const isMobile = width === 'xs';

        return (<div className={style.wrapper}>

            {dialogOpen === 'message' &&
                <MessageDialog
                    onClose={this.closeDialog}
                    {...dialogOpenProps}
                />
            }

            {!isMobile && <>
            <SecondaryNav
                closeBag={this.closeBag}
                openDiamondSideDrawer={sideDrawerOpen}
                sideDrawerProps={{ row }}
            />

            <div className={style.panelWrapper}>
                <div className={style.panelLeft}>

                    <Tabs
                        className={style.diamondsNav}
                        value={innerTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, value) => this.handleChangeInnerTab(value)}
                        aria-label="disabled tabs example"
                    >
                        <Tab label="Details" icon={<img alt="" src={`/images/details_icon${innerTab === 0 ? '_active' : ''}.svg`} />} />
                        <Tab label="Report" disabled={isParcel} icon={<img alt="" src={`/images/report_${innerTab === 1 ? 'active' : 'default'}_icon.svg`} />} />
                        <Tab label="Diagram" disabled={isParcel} icon={<img alt="" src={`/images/diagram_${innerTab === 2 ? 'active' : 'default'}.svg`} />} />
                    </Tabs>

                    <BackButton to={'/diamonds/all'} className={style.backButton} />

                    {page === 'details' && (!otherView || carouselView) &&
                        <div className={style.diamondImagesWrap}>
                            <div className={classNames(style.diamondImage, selectedDiamondImage === 0 && style.diamondImageSelected)} onClick={() => this.showFrontImage()}>
                                <img alt="" src={row.img} />
                            </div>
                            <div className={classNames(style.diamondImage, selectedDiamondImage === 1 && style.diamondImageSelected, isParcel && style.diamondImageDisabled)} onClick={() => this.showSideImage()}>
                                <img alt="" src={row.imgSide} />
                            </div>
                            <div className={classNames(style.diamondImage, selectedDiamondImage === 2 && style.diamondImageSelected, images.length === 0 && style.diamondImageDisabled)} onClick={() => this.showCarousel()}>
                                <img alt="" src={row.img} />
                            </div>
                        </div>
                    }

                </div>
                <div className={style.panelRight}>

                    <div className={style.contentWrap}>
                        <div className={style.contentWrapLeft}>


                            {!otherView && <span onClick={() => this.on360Click()}><img alt="" src="/images/diamond_360.svg" style={{ opacity: 0.5 }} /></span>}
                            {otherView && <span onClick={() => this.closeOtherView()}>
                                <span style={{ position: 'relative' }}>
                                    <img alt="" src="/images/diamond_photo.svg" />
                                    <img alt="" src="/images/back.svg" style={{ position: 'absolute', top: -20, right: -40 }} />
                                </span>
                            </span>}


                        </div>
                        <div className={style.contentWrapRight}>

                            <div className={style.contentWrapRightInner}>
                                <h3 className={style.heading}>
                                    {isParcel ? `${row.StkShape} PARCEL` : `${numeral(row.STWeight).format('0.00')} CT ${row.StkShape} DIAMOND`}
                                </h3>

                                {page === 'details' &&
                                    <div className={style.contentWrapRightInnerTableTop}>
                                        <div className={style.contentWrapRightInnerTableTopLeft}>
                                            {!isAuthorised && !row.specialOffer && <RegisterOrLoginToSeePriceNotice openEmailDialog={openEmailDialog} />}
                                            {(isAuthorised || row.specialOffer) && <PriceTag specialOffer={row.specialOffer} onClick={isAuthorised && this.openPrice} priceOrig={row.priceOrig ? getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.priceOrig, isParcel))).format('0,0.00') : false} price={getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.price, isParcel))).format('0,0.00')} isParcel={isParcel} isAuthorised={isAuthorised} />}
                                        </div>
                                        <div className={style.contentWrapRightInnerTableTopRight}>
                                            <Tooltip title={`${!isCompare ? 'Add to' : 'Remove from'} Compare`}>
                                                <IconButton size="small" onClick={() => this.toggleCompare(diamondId, !isCompare)} className={(!isCompare && style.hoverSwitch) || undefined} style={{ paddingTop: 6 }}>
                                                    {!isCompare && <React.Fragment>
                                                        <img alt="" src="/images/compare.svg" />
                                                        <img alt="" className={style.hover} src="/images/compare_hover.svg" />
                                                    </React.Fragment>}
                                                    {isCompare && <img alt="" src="/images/compare_active.svg" />}
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={`${!isCompare ? 'Add to' : 'Remove from'} Favourites`}>
                                                <IconButton size="small" onClick={() => this.toggleFav(row, !isFav)} className={(!isFav && style.hoverSwitch) || undefined}>
                                                    {!isFav && <React.Fragment>
                                                        <img alt="" src="/images/fav.svg" />
                                                        <img alt="" className={style.hover} src="/images/fav_hover.svg" />
                                                    </React.Fragment>}
                                                    {isFav && <img alt="" src="/images/fav_active.svg" />}
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                }
                            </div>

                            {page === 'details' &&
                                <div className={style.contentWrapRightInnerTableDiamondDetailsWrapper}>

                                    {!otherView && <div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Code:</b> {row.StkCodeCalcNS || '-'}
                                            </div>
                                            <div>
                                                <b>Certificate:</b> #{row.StkCertNo || '-'}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Shape:</b> {row.StkShape || '-'}
                                            </div>
                                            <div>
                                                <b>Weight:</b> {!isParcel ? numeral(row.STWeight).format('0.00') + 'ct' : (row.size || '-')}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Clarity:</b> {row.clarity || '-'}
                                            </div>
                                            <div>
                                                <b>Cut:</b> {row.cut || '-'}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Fluorescence:</b> {row.flourecence || '-'}
                                            </div>
                                            <div>
                                                <b>Symmetry:</b> {row.symmetry || '-'}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Colour:</b> {row.colour || '-'}
                                            </div>
                                            <div>
                                                <b>Polish:</b> {row.polish || '-'}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Crown:</b> {(row.StkDepth_Crown && row.StkDepth_Crown + '%') || '-'}
                                            </div>
                                            <div>
                                                <b>Pavilon:</b> {(row.StkDepth_Pavilion && row.StkDepth_Pavilion + '%') || '-'}
                                            </div>
                                        </div>
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>Table:</b> {row.StkTable ? row.StkTable + '%' : '-'}
                                            </div>
                                            <div>
                                                <b>Measurements:</b> {[row.StkMes1, row.StkMes2, row.StkMes3].map(s => s && `${s}mm` || '-').join(' x ')}
                                            </div>
                                        </div>

                                        {isAuthorised && !isParcel && 
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                <b>RAP Below:</b> {row.RAP ? row.RAP + '%' : '-'}
                                            </div>
                                            <div>
                                                <b>LAB:</b> {row.StkCertSup ? row.StkCertSup : '-'}
                                            </div>
                                        </div>}

                                        {(!isAuthorised || isParcel) && 
                                        <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                            <div>
                                                
                                            </div>
                                            <div>
                                                <b>LAB:</b> {row.StkCertSup ? row.StkCertSup : '-'}
                                            </div>
                                        </div>}
                                    </div>}

                                    {otherView && <div className={style.contentWrapRight360Wrap}>

                                        {show360View && <>
                                            {/* <img alt="" src={row.img} />
                                            */}
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <div>
                                                    360° Player: Hold and drag to orbit<br />
                                                    <br />
                                                </div> 
                                                <Images360Player 
                                                    images={[
                                                        ...new Array(video360.framesCount || 256).fill(undefined)]
                                                        .map((a, i) => {
                                                            return `${baseURL}${video360.src}/image${i}.${video360.format || 'png'}`;
                                                        })
                                                    }
                                                    height={400}
                                                />
                                            </div>
                                            
                                        </>}

                                        {carouselView && <>
                                            <CarouselView items={images} />
                                        </>}
                                    </div>}

                                </div>
                            }

                            {page === 'report' &&
                                <Report row={row} openReportPDF={() => this.openReportPDF()} certificates={certificates} />
                            }

                            {page === 'diagram' &&
                                <Diagram row={row} />
                            }

                            <div className={style.contentWrapRightInnerTableDiamondDetailsWrapper}>
                                <div className={style.contentWrapRightInnerTableDiamondDetails}>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            onClick={this.openBag}
                                            disabled={!isAuthorised}
                                        >
                                            Add to Basket
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="default"
                                            onClick={this.openBagShare}
                                        >
                                            Share
                                        </Button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {(!otherView || carouselView) &&
                        <RelatedOffers diamondId={diamondId} onItemClick={(row) => this.loadRelatedItem(row)} />
                    }

                </div>

                {!otherView &&
                    <div className={style.bigDiamond}>
                        <img alt="" src={selectedDiamondImage === 0 ? row.img : selectedDiamondImage === 1 ? row.imgSide : ''} />
                    </div>
                }
            </div>
            </>}

            {isMobile && <>
                <DiamondSideDrawer open={sideDrawerOpen} closeBag={this.closeBag} row={row} />

                <div className={stylesMobile.inner}>
                    <div className={stylesMobile.diamondImgWrap}>
                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.toggleCompare(diamondId, !isCompare); }} className={(!isCompare && stylesMobile.hoverSwitch) || undefined} style={{ paddingTop: 6 }}>
                            {!isCompare && <React.Fragment>
                                <img alt="" src="/images/compare.svg" />
                                <img alt="" className={stylesMobile.hover} src="/images/compare_hover.svg" />
                            </React.Fragment>}
                            {isCompare && <img alt="" src="/images/compare_active_brown.svg" />}
                        </IconButton>
                        <img alt="" src={row.img} width={!isParcel ? 300 : 280} style={{ bottom: !isParcel ? '-43%' : '-38%' }} className={stylesMobile.diamondImage} />
                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.toggleFav(row, !isFav); }} className={(!isFav && stylesMobile.hoverSwitch) || undefined}>
                            {!isFav && <React.Fragment>
                                <img alt="" src="/images/fav.svg" />
                                <img alt="" className={stylesMobile.hover} src="/images/fav_hover.svg" />
                            </React.Fragment>}
                            {isFav && <img alt="" src="/images/fav_active_brown.svg" />}
                        </IconButton>
                    </div>

                    <h3 className={stylesMobile.heading}>
                        {isParcel ? `${row.StkShape} PARCEL` : <>{numeral(row.STWeight).format('0.00')}CT <br />{row.StkShape} DIAMOND</>}
                    </h3>

                    {isAuthorised && <div className={stylesMobile.price}>
                        <div className={classNames(row.specialOffer && stylesMobile.specialOffer)} onClick={() => this.openPrice()}>
                            {!isParcel && <span><small>Price: </small>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></span>}
                            {isParcel && <span><small>Price per carat: </small>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></span>}
                            <img alt="" src="/images/info.svg" style={{marginTop: 4}} />
                        </div>
                    </div>}
                    {!isAuthorised && <div className={stylesMobile.registerOrLoginToSeePricesNotice}><RegisterOrLoginToSeePriceNotice openEmailDialog={openEmailDialog} /></div>}

                    <div className={stylesMobile.actions}>
                        <div>
                            <Button
                                type="button"
                                variant="contained"
                                color="secondary"
                                onClick={() => this.openBag(row)}
                                disabled={!isAuthorised}
                            >
                                Add to Basket
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="button"
                                variant="contained"
                                color="default"
                                onClick={this.openBagShare}
                            >
                                Share
                            </Button>
                        </div>
                    </div>

                    <Tabs
                        className={stylesMobile.diamondsNav}
                        value={innerTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, value) => this.handleChangeInnerTab(value)}
                        aria-label="disabled tabs example"
                    >
                        <Tab label="Details" icon={<img alt="" width={innerTab === 0 && 16} src={`/images/${innerTab === 0 ? 'details_icon_active-brown.jpg' : 'details_icon.svg'}`} />} />
                        <Tab label="Report" disabled={isParcel} icon={<img alt="" width={innerTab === 1 && 23} src={`/images/${innerTab === 1 ? 'report_default_icon_brown.jpg' : 'report_default_icon.svg'}`} />} />
                        <Tab label="Diagram" disabled={isParcel} icon={<img alt="" width={innerTab === 2 && 22} src={`/images/${innerTab === 2 ? 'diagram_default_brown.jpg' : 'diagram_default.svg'}`} />} />
                    </Tabs>

                    {innerTab === 0 &&
                        <DiamondDetailsList className={stylesMobile.diamondProperties} isParcel={isParcel} row={row} isAuthorised={isAuthorised} fxrates={fxrates} ccy={ccy} />
                    }
                    {innerTab === 1 &&
                        <div style={{padding: 24, paddingBottom: 0}}>
                            <Report row={row} openReportPDF={() => this.openReportPDF()} certificates={certificates} />
                        </div>
                    }
                    {innerTab === 2 &&
                        <Diagram row={row} isMobile={isMobile} />
                    }

                    <RelatedOffers diamondId={diamondId} onItemClick={(row) => this.loadRelatedItem(row)} />

                </div>
            </>}

        </div >);
    }
}

DiamondDetails.propTypes = {
    selectDiamondDetails: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};



export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        compareItemsList: state.diamonds.compare,
        favouriteItemsList: state.diamonds.favourite,
        diamondsData: state.diamonds.data,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(DiamondDetails)));
